import {Redirect, Route, Switch} from "react-router-dom";
import {HOME_PAGE, LOGIN_PAGE} from "../utils/routeNames";
import LoginPage from "../pages/Login/LoginPage";
import React, {useEffect} from "react";
import HomePage from "../pages/Home/";
import {useDispatch} from "react-redux";
import * as constants from "../utils/constants";
import {LOGIN_USER} from "../actions/types/ActionTypes";

export default function AppRouter() {
    const dispatch = useDispatch((state) => state.LoginReduce);

    const data = JSON.parse(localStorage.getItem(constants.LOCAL_STORAGE_KEY));
    let isAuth = data && data.token;

    useEffect(() => {
        if (isAuth) {
            dispatch({
                type: LOGIN_USER,
                token: data.token,
                uid: data.uid,
                username: data.username
            });
        }
    }, []);

    if (isAuth) {
        return (
            <Switch>
                <Route path={HOME_PAGE} component={HomePage} exact={false}/>
            </Switch>
        );
    } else {
        return (
            <Switch>
                <Route path={LOGIN_PAGE} component={LoginPage} exact={false}/>
                <Redirect exact={false} from="/" push to={LOGIN_PAGE}/>
            </Switch>
        );
    }
}